import React from "react";
import { Button as MuiButton } from "@material-ui/core";

const Button = React.memo(function Button({
  variant = "contained",
  color = "primary",
  disabled = false,
  ...props
}) {
  return (
    <MuiButton variant={variant} color={color} disabled={disabled} {...props} />
  );
});

export default Button;
